module.exports = __webpack_public_path__ + "img/рз_20.237051f3.png";